import styled from 'styled-components';

export const CheckmarkWrapper = styled.span`
  display: flex;
  margin-left: auto;
`;
